export var WRAPPER = 'inline-flex items-center cursor-pointer';
export var DISABLED_WRAPPER = 'inline-flex items-center cursor-default';
export var BASE_CHECKBOX = 'inline-flex items-center justify-center h-20 w-20 rounded-2 flex-shrink-0';
export var DEFAULT_CHECKBOX = /*#__PURE__*/"".concat(BASE_CHECKBOX, " border-2 border-solid border-gray-main");
export var CHECKED_CHECKBOX = /*#__PURE__*/"".concat(BASE_CHECKBOX, " bg-secondary-main");
export var CHECKED_DARK_CHECKBOX = /*#__PURE__*/"".concat(BASE_CHECKBOX, " bg-secondary-main");
export var ERROR_CHECKBOX = /*#__PURE__*/"".concat(BASE_CHECKBOX, " border-2 border-solid border-red-main");
export var CHECKBOX = {
  "default": DEFAULT_CHECKBOX,
  checked: CHECKED_CHECKBOX,
  'checked-dark': CHECKED_DARK_CHECKBOX,
  error: ERROR_CHECKBOX
};